/**
 * Персональные ключи MCP (подключение Claude Code) — /api/mcp-keys
 */

import { apiDelete, apiGet, apiPost } from './api';

// ApiService на не-2xx бросает «HTTP <код>: …» без тела ответа — переводим коды
const ERROR_MESSAGES = {
  401: 'Для выпуска ключа нужно заново войти через Google',
  403: 'Для вашей почты ключ выпустить нельзя',
  404: 'Подключение к Claude Code сейчас выключено или ключ не найден',
  409: 'Достигнут лимит активных ключей — отзовите ненужный и выпустите заново',
  503: 'Хранилище ключей временно недоступно, попробуйте позже'
};

/**
 * 401 — и reauth_required (вход через Google старше 10 минут), и истёкшая
 * сессия: в обоих случаях лечится новым входом, поэтому флаг один.
 */
function toUserError(error) {
  const match = /^HTTP (\d{3})/.exec(error?.message || '');
  const status = match ? Number(match[1]) : null;
  const userError = new Error((status && ERROR_MESSAGES[status]) || 'Не удалось выполнить запрос, попробуйте ещё раз');
  userError.reauthRequired = status === 401;
  return userError;
}

async function call(request) {
  try {
    return await request();
  } catch (error) {
    throw toUserError(error);
  }
}

const McpKeysService = {
  /** @returns {Promise<{enabled: boolean, publicUrl?: string, ttlDays?: number, idleDays?: number, keys?: Array}>} */
  getStatus: () => call(() => apiGet('/mcp-keys')),

  /**
   * Ошибка с reauthRequired=true — нужен новый вход через Google.
   * @returns {Promise<{key: string, command: string, id: string, label: string, createdAt: string, expiresAt: string}>}
   */
  issueKey: (label) => call(() => apiPost('/mcp-keys', { label })),

  revokeKey: (id) => call(() => apiDelete(`/mcp-keys/${encodeURIComponent(id)}`))
};

export default McpKeysService;
